import type React from 'react';
import {Outlet} from 'react-router';
import {Box} from '@mui/system';
import {SimpleEnvWrapper} from '~/jobs/wrapper/SimpleEnvWrapper';
import {DRAWER_HEADER_HEIGHT_LG} from "~/components/main/drawer/DrawerConstants.ts";

/** Databag-loading wrapper for Explore Categories and the Category Profile. */
export const CategoryModuleLayout: React.FC = () => (
    <SimpleEnvWrapper state={{fluid: true, appSection: 'category-profile'}}>
        <Box sx={{p: 2, height: `calc(100vh - ${DRAWER_HEADER_HEIGHT_LG}px)`, overflow: 'auto'}}>
            <Outlet/>
        </Box>
    </SimpleEnvWrapper>
);
